const ERROR_TICKET_EXPIRED = "Ticket Expired"
const ERROR_LOGIN_FAILED = "Login Failed"

export default {
  ERROR_TICKET_EXPIRED,
  ERROR_LOGIN_FAILED
}
